<template>
    <div :class="{'sm:ml-22': !as_component}">
        <section class="mt-3 sm:ml-5 mb-20 max-w-6xl sm:w-max bg-squares text-panelsText dark:bg-dark.tableBG dark:text-dark.textOnBkg p-1 px-7 pr-10 pb-8 rounded-xl border border-sepBorder dark:border-dark.sepBorder">
            <div class="mt-5">
                <h2 class="font-semibold text-lg flex items-center"><logo-component :display_moto="false" /><div class="ml-3 mt-4">Desktop</div></h2>
                <span class="text-red-300 sm:hidden">{{ $t('not_available_on_mobile') }}<br /></span>
                <span><strong>* {{ $t('for_loginmate_1') }} <a class="underline" href="https://www.google.com/chrome/" target="_blank">{{ $t('for_loginmate_2') }}</a> {{ $t('for_loginmate_3') }}!</strong><br /></span>
                <span>{{ $t('for_cxoneapp_1') }}</span><br />
                <section class="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-full">
                    <slot v-for="(version, index) in cx1_versions" :key="index">
                        <div class="p-5 pb-10 bg-gray-100 rounded-lg shadow-light dark:shadow-dark m-5 text-center cursor-pointer hover:shadow-light dark:shadow-dark dark:bg-dark.panels dark:hover:bg-opacity-60 hover:bg-gray-200" 
                            @click="download(version.name, 'cxone_app')">
                            <font-awesome-icon v-if="version.os_version.substr(0,7) == 'Windows'" icon="fa-brands fa-windows" class="text-4xl my-5" />
                            <font-awesome-icon v-else icon="fa-brands fa-apple" class="text-4xl my-5" />
                            <h3 class="font-bold mb-4 capitalize">
                                {{ version.os_version }}
                            </h3>
                            <span class="font-bold" style="color:#10B981;font-size:40px;">X</span><br />
                        </div>
                    </slot>
                </section>
                <section v-if="cx1_versions.length == 0 && loading" class="text-center p-10">
                    <font-awesome-icon icon="fas fa-spinner" class="animate-spin text-2xl text-gray-500 dark:text-gray-200" />
                </section>
            </div>
        </section>
    </div>
</template>

<script setup>
    import logoComponent from "@/components/logo.vue"
</script>

<script>
    import { useAuthStore } from '@/stores/auth';
    export default {
        props: ['as_component'],
        components() {
            logoComponent
        },
        data() {
            return {
                cx1_versions: [],
                cx1_versions_block: false,
                loading:false,
            }
        },
        computed: {
            authStore() {
                return useAuthStore();
            },
            myself() {
                return this.authStore.myself;
            },
            permissions() {
                return this.authStore.permissions;
            },
        },
        methods: {
            download(file, app) {
                let baseURL = import.meta.env.VITE_API_URL;
                if (window.location.host === "creatorx.one") {
                    baseURL = import.meta.env.VITE_API_URL_NO_CLOUDFLARE;
                }
                window.open(`${baseURL}githubDownload/?q=download&file=${file}&app=${app}&userToken=${this.$cookies.get('userToken')}&companyID=${this.$cookies.get('c_id')}`)
            },
            get_cx1_versions() {
                this.loading = true
                this.$axios.get(`githubDownload/?q=assets&app=cxone_app&userToken=${this.$cookies.get('userToken')}&companyID=${this.$cookies.get('c_id')}`).then((result) => {
                    this.cx1_versions = result.data
                }, (error) => {
                    console.log(error);
                }).finally(() => {this.loading = false});
            },
        },
        created() {
            this.get_cx1_versions();
        }
    }
</script>
